import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchManufacturerDetail(id) {
  const { data: raw } = await request.get(`/manufacturer/${id}`);
  return parseVer4DetailResponse(raw);
}
